$(function() {

	$.fn.listLoadModeDisable = function() {
		$(this).find('.load-more').attr('disabled', 'disabled');
	}

	$.fn.listLoadModeEnable = function() {
		$(this).find('.load-more').removeAttr('disabled');
	}

	let listLoadRequests = [];
	$.fn.listLoadItems = function(page, callback) {
		// Kill all other requests.
		for (i in listLoadRequests) {
			listLoadRequests[i].abort();
			listLoadRequests.splice(i, 1);
		}

		// Load this list.
		let list = $(this);
		list.find('.rcp-c').addClass('loading');

		data = {};
		if ($(this).attr('data-params').trim()) {
			data = $.parseJSON($(this).attr('data-params'));
		}
		data.page = page;
		data.perPage = $(this).listGetPerPage();
		data.sort = $(this).listGetSort();
		request = $.ajax({
			type: 'GET',
			url: $(this).listGetUrl(),
			data: data,
			success: function(response) {
				list.find('.rcp-c').removeClass('loading');
				list.listLoadModeEnable();
				callback(response);
				if (response.pagination.page >= response.pagination.pages) {
					list.listSetFullyLoaded();
				}
				if (response.pagination.page == 1 && !response.pagination.total) {
					list.find('.no-results').removeClass('hidden');
					list.find('.load-more').addClass('hidden');
				} else {
					list.find('.no-results').addClass('hidden');
					list.find('.load-more').removeClass('hidden');
				}
				if ($('body').hasClass('recipes--index') && typeof response.url == 'string') {
					window.history.pushState("", "", response.url);
				}
				$(window).trigger('ajaxFilter');
			},
			error: function(response) {
				list.find('.rcp-c').removeClass('loading');
				list.listLoadModeEnable();
			},
		});

		// Add to requests.
		listLoadRequests.push(request);
	}

	$.fn.listSetFullyLoaded = function() {
		$(this).addClass('fully-loaded');
	}

	$.fn.listReset = function() {
		$(this).removeClass('fully-loaded');
	}

	$.fn.listLoadPage = function(page) {
		let list = $(this);
		$(this).listLoadItems(page, function(response) {
			list.listAddPageSeparator(response.pagination.page);
			list.listAddItems(response);
			list.listSetPage(response.pagination.page);
		});
	};

	$.fn.listReload = function(callback) {
		let list = $(this);
		let page = 1;
		$(this).listLoadItems(page, function(response) {
			list.listReset();
			list.listRemoveAllItems();
			list.listAddItems(response);
			list.listSetPage(page);
			if (typeof callback == 'function') {
				callback(response);
			}
		});
	};

	$.fn.listRemoveAllItems = function() {
		$(this).find('.item-list .item').remove();
	}

	$.fn.listAddPageSeparator = function(page) {
		let container = $(this).find('.item-list');
		container.append('<div data-page-separator="' + page + '"></div>');
	}

	$.fn.listAddItems = function(response) {
		let container = $(this).find('.item-list');

		if (typeof response.data != 'undefined') {

			let position = 1;
			let ledger = {};
			let recipes = response.data;
			let lastItem = false;
			while (recipes.length || (typeof ledger[position - 1] != 'undefined' && ledger[position - 1] == 'recipe')) {

				ledger[position] = false;

				if (typeof response.ads != 'undefined') {
					for (let i in response.ads) {
						if (response.ads[i].position == position) {
							container.append(response.ads[i].template);
							ledger[position] = 'ad';
						}
					}
				}

				if (!ledger[position] && recipes.length) {
					let recipe = recipes.shift();
					container.append(recipe.templates['grid.standard']);
					ledger[position] = 'recipe';
				}

				position++;

			}

		}
	}

	$.fn.listAddPage = function() {
		$(this).attr('data-page', $(this).listGetPage() + 1);
	};

	$.fn.listGetUrl = function() {
		return $(this).attr('data-url');
	}

	$.fn.listGetPage = function() {
		return parseInt($(this).attr('data-page'));
	}

	$.fn.listSetPage = function(page) {
		return $(this).attr('data-page', page);
	}

	$.fn.listGetPerPage = function() {
		return parseInt($(this).attr('data-per-page'));
	}

	$.fn.listGetSort = function() {
		return $(this).attr('data-sort');
	}

	$.fn.listSetSort = function(sort) {
		return $(this).attr('data-sort', sort);
	}

	$.fn.listSetParams = function(params) {
		return $(this).attr('data-params', JSON.stringify(params));
	}

	$(document).delegate('[data-list] .load-more', 'click', function(event) {
		event.preventDefault();
		let list = $(this).closest('[data-list]');
		list.listLoadModeDisable();
		list.listLoadPage(list.listGetPage() + 1);
	});

	$(document).delegate('[data-list-set-sort]', 'click', function(event) {
		let list = $(this).closest('[data-list]');
		list.listSetSort($(this).attr('data-list-set-sort'));
		list.listReload();
	});

	// Sjednotit seznam se zaškrtnutím.
	$('[data-list]').each(function() {
		$(this).find('[data-list-set-sort="' + $(this).attr('data-sort') + '"]').click();
	});


});
